<template>
    <BasePopover
        v-if="asPopup"
        width="500">
        <template #reference>
            <font-awesome-layers class="fa-xl">
                <font-awesome-icon
                    icon="circle"
                    :class="iconClass" />
                <font-awesome-icon
                    class="text-white"
                    transform="shrink-8"
                    :icon="icon" />
            </font-awesome-layers>
        </template>
        <div
            class="callout"
            :class="calloutClass">
            <slot name="icon">
                <font-awesome-icon
                    :class="iconClass"
                    size="lg"
                    :icon="icon" />
            </slot>
            <div>
                <h5
                    v-if="title"
                    :class="titleClass">
                    {{ title }}
                </h5>
                <p class="mb-0 text-sm">
                    <slot>
                        {{ message }}
                    </slot>
                </p>
            </div>
        </div>
    </BasePopover>
    <div
        v-else
        class="callout"
        :class="calloutClass">
        <slot name="icon">
            <font-awesome-icon
                :class="iconClass"
                size="lg"
                :icon="icon" />
        </slot>
        <div>
            <h5
                v-if="title"
                :class="titleClass">
                {{ title }}
            </h5>
            <p class="mb-0 text-sm">
                <slot>
                    {{ message }}
                </slot>
            </p>
        </div>
    </div>
</template>
<script>

export default {
    name: 'BaseCallout',
    props: {
        type: {
            type: String,
            default: 'info',
            description: 'Alert type'
        },
        icon: {
            type: String,
            default: '',
            description: 'Alert icon to display'
        },
        message: {
            type: String,
            default: '',
            description: 'Alert message to display'
        },
        title: {
            type: String,
            default: '',
            description: 'Alert title to display'
        },
        small: {
            type: Boolean,
            default: false,
            description: 'Small alert'
        },
        asPopup: {
            type: Boolean,
            default: false,
            description: 'Small alert'
        }
    },
    data() {
        return {
            open: false
        }
    },
    computed: {
        calloutClass() {
            return {
                'callout-small': this.small,
                [`callout-${this.type}`]: true
            };
        },
        iconClass() {
            return `text-${this.type}`;
        },
        titleClass() {
            return `text-sm text-${this.type}`;
        }
    }
};
</script>

<style lang="scss">
.callout {
    display: flex;
    align-items: center;
    padding: 1rem;
    gap: 1rem;
    border-radius: 0.25rem;
    border-style: solid;
    border-width: 1px;
    border-left-width: 5px;
    border-color: $gray-200;

    &.callout-small {
        padding: 0.5rem;
        padding-left: 1rem;
    }

    &.callout-primary {
        border-left-color: $primary;
    }

    &.callout-info {
        border-left-color: $info;
    }

    &.callout-danger {
        border-left-color: $danger;
    }

    &.callout-warning {
        border-left-color: $warning;
    }

    &.callout-success {
        border-left-color: $success;
    }

    &.callout-dashboard {
        border-left-color: $dashboard;
    }

    &.callout-contact {
        border-left-color: $contact;
    }

    &.callout-events {
        border-left-color: $events;
    }

    &.callout-appointments {
        border-left-color: $appointments;
    }

    &.callout-resources {
        border-left-color: $resources;
    }

    &.callout-accounting {
        border-left-color: $accounting;
    }

    &.callout-memberships {
        border-left-color: $memberships;
    }

    &.callout-fundraising {
        border-left-color: $fundraising;
    }

    &.callout-newsletter {
        border-left-color: $newsletter;
    }

    &.callout-subscription {
        border-left-color: $subscription;
    }

    &.callout-messages {
        border-left-color: $messages;
    }

    &.callout-settings {
        border-left-color: $settings;
    }

    &.callout-system {
        border-left-color: $system;
    }
}

</style>

